import MetaMaskIcon from "../../images/metamask.svg"
import WalletConnectIcon from "../../images/walletConnect.svg"
import DiverWalletIcon from "../../images/diver.svg"

export const WalletImageMapper: Record<string, string> = {
  DiverWallet: DiverWalletIcon,
  MetaMask: MetaMaskIcon,
  WalletConnect: WalletConnectIcon,
}
